import { Box, Typography, Skeleton } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { tokens } from '../../theme/tokens';

const AiInsightCard = ({ loading, text, error, label = 'Resumen del copiloto' }) => {
  return (
    <Box
      sx={{
        backgroundImage: tokens.gradient.soft,
        border: '1px solid rgba(108,114,255,.28)',
        borderRadius: `${tokens.radius.lg}px`,
        p: 2.5,
        mb: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <AutoAwesomeIcon sx={{ fontSize: 15, color: tokens.colors.cyan }} />
        <Typography sx={{ fontSize: 11.5, fontWeight: 700, letterSpacing: '.4px', textTransform: 'uppercase', color: tokens.colors.cyan }}>
          {label}
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ mt: 1.5 }}>
          <Skeleton width="90%" height={16} />
          <Skeleton width="70%" height={16} />
        </Box>
      ) : error ? (
        <Typography sx={{ mt: 1.5, fontSize: 13, color: tokens.colors.muted }}>
          No se pudo generar el resumen en este momento.
        </Typography>
      ) : (
        <Typography sx={{ mt: 1.5, fontSize: 14, lineHeight: 1.62, color: tokens.colors.txt }}>
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default AiInsightCard;